export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  // UI без копеек; в БД по-прежнему Decimal с сотыми (налог/комиссия позже).
  return `${Math.round(n).toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ₽`;
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ru-RU');
}

function billingBalance(data) {
  if (data.status === 'debt') {
    return {
      label: 'Долг',
      value: formatMoney(data.debt),
      tone: 'text-error',
      note: 'Отрицательный баланс — это долг, не «минус предоплата».',
    };
  }
  if (data.status === 'prepaid') {
    return { label: 'Предоплата', value: formatMoney(data.prepaid), tone: 'text-success' };
  }
  return { label: 'Баланс', value: '0 ₽', note: 'Нет предоплаты и нет долга.' };
}

export function BillingFacts({ data, extras = [] }) {
  if (!data) return null;
  const balance = billingBalance(data);
  const lastPayment = data.last_payment_at
    ? `${formatDateTime(data.last_payment_at)}${
        data.last_payment_amount ? ` · ${formatMoney(data.last_payment_amount)}` : ''
      }`
    : '—';
  const items = [
    { label: balance.label, value: balance.value, tone: balance.tone },
    { label: 'Всего внесено', value: formatMoney(data.total_deposited) },
    { label: 'Последний платёж', value: lastPayment },
    ...extras,
  ];
  return (
    <div className="billing-facts">
      <dl className="billing-facts-list">
        {items.map((item) => (
          <div key={item.label} className="billing-facts-row">
            <dt>{item.label}</dt>
            <dd className={item.tone || undefined}>{item.value}</dd>
          </div>
        ))}
      </dl>
      {balance.note ? <p className="billing-facts-note">{balance.note}</p> : null}
    </div>
  );
}

export function OzonBankMark({ className = '' }) {
  return (
    <svg
      className={`billing-ozon-mark ${className}`.trim()}
      viewBox="0 0 24 24"
      width="20"
      height="20"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="24" height="24" rx="6" fill="#005BFF" />
      <circle cx="12" cy="12" r="5.4" fill="none" stroke="#fff" strokeWidth="2.3" />
    </svg>
  );
}

export function TransactionsTable({ items }) {
  if (!items?.length) {
    return <p className="text-secondary">Пока нет операций.</p>;
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Дата</th>
          <th>Тип</th>
          <th>Сумма</th>
          <th>Комментарий</th>
        </tr>
      </thead>
      <tbody>
        {items.map((tx) => (
          <tr key={tx.id}>
            <td>{formatDateTime(tx.created_at)}</td>
            <td>{tx.type_label || tx.type}</td>
            <td className={Number(tx.amount) < 0 ? 'text-error' : 'text-success'}>
              {formatMoney(tx.amount)}
            </td>
            <td>{tx.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
